import { Resort } from "../../../types/Resort"
import React, { Fragment, useCallback } from "react"
import css from "@css/modules/Resort.module.scss"
import { MultipleResortChart } from "../../Listings/Chart/MultipleResortChart"
import { Ellipse } from "@css/icons/SVG"
import Link from "next/link"
import { NumberAnimation } from "../../Animation/Number"
import { Dues } from "./Dues"
import { Image } from "../../Image"
import { useGeneralData } from "../../GeneralData/GeneralData"
import { Intersection } from "../../Intersection/Intersection"
import { SlideAppear } from "../../Animation/SlideAppear"

function renderCircle(val: number) {
    return <Ellipse value={val} className={css.circleRoot} circleClass={css.circle} />
}

const chartOptions = {
    tension: 0.3
}

type Props = {
    resort: Resort
}

export function ResortFinancials({ resort }: Props) {
    const { valueGrade } = resort
    const { gradingSystemUrl } = useGeneralData()
    const { valueGradeProps } = valueGrade || {}
    const render = useCallback(
        ({ active }: { active: boolean }) => {
            if (!valueGrade) return null
            return (
                <>
                    <div className={css.vote}>
                        <div className={css.voteTitle}>Value Grade</div>
                        <div className={css.circleContainer}>
                            <div className={css.circleText}>
                                {valueGrade?.grade}
                                <span>Grade</span>
                            </div>
                            <NumberAnimation start={active} value={valueGrade?.gradePercentage}>
                                {renderCircle}
                            </NumberAnimation>
                        </div>

                        {!!valueGradeProps?.length && (
                            <div className={css.props}>
                                {valueGradeProps.map((i, index) => {
                                    return (
                                        <Fragment key={index}>
                                            <div className={css.cell0}>{i.icon && <Image {...i.icon} alt={i.icon.alternativeText || i.text} />}</div>
                                            <div className={css.cell1}>{i.text}</div>
                                            <div className={css.cell2}>{i.value}</div>
                                        </Fragment>
                                    )
                                })}
                            </div>
                        )}
                        {gradingSystemUrl && (
                            <Link href={gradingSystemUrl} className={css.link}>
                                Learn more about our grading system
                            </Link>
                        )}
                    </div>
                    <Dues resort={resort} />
                    <div className={css.chart}>
                        <MultipleResortChart
                            chartOptions={chartOptions}
                            className={css.chartInject}
                            defaultresorts={resort.id.toString()}
                            showresorts={undefined}
                            description={undefined}
                            defaultprice={undefined}
                            onlydisney={undefined}
                            onlynondisney={undefined}
                        />
                    </div>
                </>
            )
        },
        [valueGradeProps]
    )
    if (!valueGrade) return null
    return (
        <SlideAppear>
            <h3 className={css.resortFinancingTitle} id="resort-financing">
                Resort Financials <div className={css.line} />
            </h3>
            <Intersection className={css.resortFinancing} once render={render} />
        </SlideAppear>
    )
}
